export const initialState = {
  email: '',
  token: '',
  wardList: [],
  errors: {},
  emailValidated: false,
};
